export const addToLocalStorage = (where, data) => {
  const existingData = JSON.parse(localStorage.getItem(where)) || [];
  const updatedData = [...existingData, data];
  localStorage.setItem(where, JSON.stringify(updatedData));
};

export const updateInLocalStorage = (where, id, updatedFields) => {
  const existingData = JSON.parse(localStorage.getItem(where)) || [];
  const updatedData = existingData.map((item) =>
    item.id === id ? { ...item, ...updatedFields } : item,
  );
  localStorage.setItem(where, JSON.stringify(updatedData));
};

export const deleteFromLocalStorage = (where, id) => {
  const existingData = JSON.parse(localStorage.getItem(where)) || [];
  const updatedData = existingData.filter((item) => item.id !== id);
  localStorage.setItem(where, JSON.stringify(updatedData));
};
